import { render, staticRenderFns } from "./EditarPatrimonioView.vue?vue&type=template&id=76b8d25a"
import script from "./EditarPatrimonioView.vue?vue&type=script&lang=js"
export * from "./EditarPatrimonioView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports